import React, { useState, useEffect, useCallback } from 'react'
import { Modal, Form, Row, Col, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ArraySelect from '../Select/ArraySelect'
import { ButtonWithLoadingState } from '../Buttons'
import { emptyGuid, isEmptyGuid } from '../../utils/emptyGuid'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { makeCall } from '../../utils/api/makeCall'

const StorehouseChangeModal = ({ shippingOrderId, storehouseId, handleClose }) => {
    const { t } = useTranslation()
    const [, setErrorStates] = useState({})
    const [loadingStates, setLoadingStates] = useState({})
    const [storehouses, setStorehouses] = useState([])
    const [newStorehouseId, setNewStorehouseId] = useState(emptyGuid);

    const loadStorehouses = useCallback(async () => {
        await makeCall('loadStorehouses', async () => {
            var resp = await apiClient.getJson(APIEndpoints.storehouses())
            setStorehouses(resp.filter(item => item.id !== storehouseId))
        }, setErrorStates, setLoadingStates)
    },
        [storehouseId]
    )
    useEffect(() => {
        loadStorehouses()
    }, [loadStorehouses])

    const handleSubmit = async (event) => {
        event.preventDefault()
        event.stopPropagation()
        await makeCall('changeStorehouse', async () => {
            let params = {
                storehouseId: newStorehouseId
            }
            await apiClient.postJson(APIEndpoints.withdrawals(shippingOrderId).changeStorehouse, params)
            handleClose(true)
        }, setErrorStates, setLoadingStates)
    }

    return (
        <Modal style={{ textAlign: "center" }} centered show={true} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton={handleClose}>
                <Modal.Title >{t('withdrawalPage:changeStorehouseTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Form
                    id="my-form"
                    onSubmit={handleSubmit}
                >
                    <Form.Group className="mb-3" as={Row}>
                        <Form.Label column>{t('withdrawalsTable:warehouse')}</Form.Label>
                        <Col>
                            <ArraySelect
                                value={newStorehouseId ?? emptyGuid}
                                options={storehouses}
                                noAutoSelect
                                name='storehouses'
                                onChange={(e) => setNewStorehouseId(e.target.value)}
                                returnEvent
                            />
                        </Col>
                    </Form.Group>
                    <>{t('withdrawalPage:changeStorehouseBody')}<br /><br /></>
                </Form>
            </Modal.Body >
            <Modal.Footer>
                <Button variant="secondary" onClick={() => handleClose(false)}>{t('cancelButton')}</Button>
                <ButtonWithLoadingState
                    buttonText={t('saveButton')}
                    loadingText={t('saveButton')}
                    type="submit"
                    form="my-form"
                    loading={loadingStates.changeStorehouse}
                    disabled={isEmptyGuid(newStorehouseId) || loadingStates.changeStorehouse}
                />
            </Modal.Footer>
        </Modal>
    )
}

export default StorehouseChangeModal